import { render, staticRenderFns } from "./editWhatnow.vue?vue&type=template&id=0bcf6fd4&scoped=true"
import script from "./editWhatnow.vue?vue&type=script&lang=js"
export * from "./editWhatnow.vue?vue&type=script&lang=js"
import style0 from "./editWhatnow.vue?vue&type=style&index=0&id=0bcf6fd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcf6fd4",
  null
  
)

export default component.exports